import { Box, CssBaseline, Toolbar } from "@mui/material";
import { Outlet } from "react-router-dom";

import SideBar from "../sidebar/SideBar";

const drawerWidth = 268;

const Layout = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <SideBar />
      <Box
        component="main"
        minHeight="100vh"
        bgcolor="background.default"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          px: { xs: 2, md: 4 },
          py: 3,
          pb: 6,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        <Box sx={{ maxWidth: 1480, mx: "auto" }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
